import { useCallback, useMemo } from "react";
var useFilters = function (setCertType, setSearchProjectId, setSearchTitleCertificate, setCertificateTrigger) {
    var handleFilterChange = useCallback(function (setter) {
        return function (data) {
            if (Array.isArray(data)) {
                data.forEach(function (item) { return setter(item.id); });
            }
            else {
                setter(data.id);
            }
        };
    }, []);
    var filterCertType = handleFilterChange(setCertType);
    var filterProject = handleFilterChange(setSearchProjectId);
    var onChangeFullTextSearch = useCallback(function (e) {
        var trimmed = e.trim();
        if (trimmed.length > 2 || trimmed === "") {
            setSearchTitleCertificate(trimmed);
        }
    }, []);
    var clearFilter = useCallback(function () {
        [setCertType, setSearchProjectId, setSearchTitleCertificate].forEach(function (fn) {
            return fn("");
        });
        setCertificateTrigger(true);
    }, []);
    return useMemo(function () { return ({
        filterCertType: filterCertType,
        filterProject: filterProject,
        onChangeFullTextSearch: onChangeFullTextSearch,
        clearFilter: clearFilter,
    }); }, [filterCertType, filterProject, onChangeFullTextSearch, clearFilter]);
};
export default useFilters;
